import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { clearAdminDirty, getAdminDirtyLabel, isAdminDirty } from "../adminDirty";
import "./adminTabs.css";

const TABS = [
  { path: "/admin/rules", label: "Rules" },
  { path: "/admin/customize-spot", label: "Customise Categories" },
  { path: "/admin/jury", label: "Jury" },
  { path: "/admin/uploads", label: "Uploads" },
  { path: "/admin/mosaic", label: "Mosaic" },
];

export default function AdminTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  const cleaned =
    location.pathname.endsWith("/") && location.pathname !== "/"
      ? location.pathname.slice(0, -1)
      : location.pathname;

  const visible = TABS.some((t) => t.path === cleaned);
  if (!visible) return null;

  const go = async (path) => {
    if (path === cleaned) return;
    if (isAdminDirty()) {
      const label = getAdminDirtyLabel();
      const result = await Swal.fire({
        title: "Unsaved changes",
        text: label
          ? `Please save your changes on ${label} before leaving.`
          : "Please save your changes before leaving this page.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Leave without saving",
        cancelButtonText: "Stay",
        confirmButtonColor: "#E25569",
      });
      if (!result.isConfirmed) return;
      clearAdminDirty();
    }
    navigate(path);
  };

  return (
    <nav className="admin-tabs" aria-label="Admin sections">
      {TABS.map((tab) => {
        const active = cleaned === tab.path;
        return (
          <button
            key={tab.path}
            type="button"
            className={`admin-tab${active ? " active" : ""}`}
            aria-current={active ? "page" : undefined}
            onClick={() => go(tab.path)}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}
